import React from 'react';

interface RolesContextProps {
  isAdmin: boolean;
  isModerationViewer: boolean;
  isSuperAdmin: boolean;
}

export const RolesContext = React.createContext<RolesContextProps>({
  isAdmin: false,
  isModerationViewer: false,
  isSuperAdmin: false
});

export const useRolesContext = () => React.useContext(RolesContext) as RolesContextProps;
